import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Row } from "@/components/customComponents";

interface IAdminViewBannerProps {
  creatorId: string;
}

const AdminViewBanner = ({ creatorId }: IAdminViewBannerProps) => (
  <Row className="items-center gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-2">
    <Text variant={TextVariants.LABEL_SMALL_BOLD} className="text-amber-600 dark:text-amber-400">
      Viewing as admin:
    </Text>
    <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-amber-700 dark:text-amber-300">
      {creatorId}
    </Text>
  </Row>
);

export default AdminViewBanner;
